import LoginManagementService from "@assets/js/imaios-connection-management/login-management-service";
import NOTIFICATIONS from "@assets/js/notifications.constant";
import {STORAGE_KEY} from "./config.constant";
import { get } from "../imaios-global/imaios-global";
import { TemporaryStorageService } from "@imaios-js/utils";

const SCRIPT_NAME = 'imaios-connection-management';

function notifyLogout() {
	imaios.pubsub.publish(NOTIFICATIONS.LOGOUT);
}

// Make "B2B Administration" entry visibile if available
async function refreshB2BAdministration() {
	const element = document.querySelectorAll('[data-header="b2b-admin-entry"]');

	if (element) {
		await LoginManagementService.awaitConnection();
		const information = TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION);
		if (information?.isB2BAdministrator) {
			Array.from(element).forEach((el) => {
				el.classList.remove('d-none');
			})
		}
	}
}

async function refreshAnatomy(LoginManagementService) {
	await LoginManagementService.awaitConnection();
	LoginManagementService.deleteSubscriptionsTags();
}

function initialize() {
	if (get(SCRIPT_NAME) !== true) {
		imaios.store(SCRIPT_NAME, true);
		imaios.store('login-manager', LoginManagementService);

		void refreshB2BAdministration();
		void refreshAnatomy(LoginManagementService);

		Array.from(document.querySelectorAll('.imaios-logout')).forEach(element => {
			element.addEventListener('click', notifyLogout);
		});

		if (
			window.location.search.length > 0 &&
			window.location.href.includes('previous_imaios_action')
		) {
			const tokens = window.location.href.split('?');
			if (tokens.length === 2) {
				const patterns = [
					'previous_imaios_action=logout',
					'previous_imaios_action=login'
				];

				const search = tokens[1];
				patterns.forEach(pattern => {
					if (search.includes(pattern)) {
						notifyLogout();
						const querySearch = new URLSearchParams(search.replace(pattern, ''));
						history.pushState({}, '',  window.location.pathname + (querySearch.toString().length > 0 ? '?' + querySearch.toString() :''));
					}
				});
			}
		}

		LoginManagementService.loadLogin();
	}
}

window.addEventListener('pageshow', event => {
	if (event.persisted) {
		initialize();
	}
});

window.addEventListener('pagehide', event => {
	imaios.store(SCRIPT_NAME, false);
});

initialize();
